import api from "./core";

const basePath = "api/core/Reports";
const reportBasePath = "api/CustomReport";
const config = require("./serverCfg").default;

export default {
  query() {
    return api.post(`${basePath}`);
  },
  getUrl(category) {
    return api.get(`${basePath}/GetUrl/${category}`);
  },
  downloadCustomReport(reportApiUrl, reportUrl, filters) {
    return fetch(`${reportApiUrl}/${reportBasePath}/Download/${reportUrl}`, {
      method: "POST",
      body: JSON.stringify(filters),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${config.token}`
      }
    });
  }
};
